import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class Answer extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/questionnaire/answer'
    super(store, path)
  }
}
